import axios from 'axios'

const groupAnswersThisVisit = new Map()
const activeSources = new Set()
let visitNumber = 0

function vueContainer() {
  return typeof document !== 'undefined' ? document.getElementById('vue-container') : null
}

function chartDataUrl() {
  const container = vueContainer()
  return container ? container.dataset.chartDataUrl : ''
}

function chartGroups() {
  const container = vueContainer()
  try {
    return JSON.parse(container?.dataset.chartGroups || '{}')
  } catch (error) {
    return {}
  }
}

function groupForSection(section) {
  return chartGroups()[section] || section
}

function sectionsInGroup(group) {
  const groups = chartGroups()
  const sections = Object.keys(groups).filter((section) => groups[section] === group)
  return sections.length ? sections : [group]
}

function filterFingerprint(filterParams) {
  const params = filterParams || {}
  const normalized = {}
  Object.keys(params).sort().forEach((key) => {
    const value = params[key]
    if (value === null || value === undefined || value === '') return
    normalized[key] = Array.isArray(value) ? [...value].sort() : value
  })
  return JSON.stringify(normalized)
}

function requestSections(sections, filterParams) {
  const source = axios.CancelToken.source()
  activeSources.add(source)
  return axios
    .get(chartDataUrl(), {
      params: { sections: sections.join(","), ...filterParams },
      cancelToken: source.token
    })
    .finally(() => {
      activeSources.delete(source)
    })
    .then(({ data }) => data.data)
    .catch((error) => {
      if (axios.isCancel(error)) return new Promise(() => {})
      throw error
    })
}

function inOwnTaskUnlessLeft(value) {
  const visit = visitNumber
  return new Promise((resolve) => {
    setTimeout(() => {
      if (visit === visitNumber) resolve(value)
    })
  })
}

function requestChartData(section, filterParams) {
  return requestSections([section], filterParams).then((sectionsData) => sectionsData[section])
}

function requestGroupChartData(section, filterParams) {
  const group = groupForSection(section)
  const answerKey = `${chartDataUrl()}|${group}|${filterFingerprint(filterParams)}`
  if (!groupAnswersThisVisit.has(answerKey)) {
    const answer = requestSections(sectionsInGroup(group), filterParams)
    answer.catch(() => groupAnswersThisVisit.delete(answerKey))
    groupAnswersThisVisit.set(answerKey, answer)
  }
  return groupAnswersThisVisit.get(answerKey).then((sectionsData) => inOwnTaskUnlessLeft(sectionsData[section]))
}

function forgetVisitChartData() {
  visitNumber += 1
  activeSources.forEach((source) => source.cancel())
  activeSources.clear()
  groupAnswersThisVisit.clear()
}

if (typeof document !== 'undefined') {
  document.addEventListener('turbolinks:visit', forgetVisitChartData)
}

export default { requestChartData, requestGroupChartData }
